/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PolarisShareViewEntrypointProps } from './polarisShareView.entrypoint.types.tsx';

type ShareViewEntryPointComponent = EntryPointComponent<
	{},
	{},
	PolarisShareViewEntrypointProps,
	{} | null
>;

export const shareViewEntryPoint: EntryPoint<ShareViewEntryPointComponent, {}> = createEntryPoint({
	root: JSResourceForUserVisible<ShareViewEntryPointComponent>(
		/* webpackChunkName: "async-polaris-share-view-entrypoint" */ './PolarisShareViewPage.tsx',
	),
	getPreloadProps: () => ({}),
});
